var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcoLocationDotOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-dot",
    clipPath: "url(#clip0_968_69124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 0.00976562C11.312 0.00976562 14 2.69777 14 6.00977C14 8.44817 13.1552 9.13617 8.5952 15.6962C8.4384 15.9138 8.2208 16.0098 8 16.0098C7.7504 16.0098 7.5328 15.917 7.376 15.6962C2.8128 9.13297 2 8.44497 2 6.00977C2 2.69457 4.656 0.00976562 8 0.00976562ZM8 14.8194C12.3744 8.47697 13.0016 8.00657 13.0016 6.00657C13.0016 3.25777 10.752 1.00497 8 1.00497C5.2192 1.00497 2.9984 3.25457 2.9984 6.00657C3.0016 8.00977 3.5936 8.50897 8 14.8194ZM8 3.50737C9.376 3.50737 10.4992 4.63377 10.4992 6.00657C10.4992 7.41137 9.3728 8.50577 8 8.50577C6.5952 8.50577 5.5008 7.41137 5.5008 6.00657C5.5008 4.63377 6.5952 3.50737 8 3.50737ZM8 7.50737C8.8128 7.50737 9.5008 6.85137 9.5008 6.00657C9.5008 5.19377 8.8128 4.50577 8 4.50577C7.1552 4.50577 6.4992 5.19377 6.4992 6.00657C6.4992 6.85137 7.1552 7.50737 8 7.50737Z",
    fill: "#FF590B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_968_69124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLocationDotOrange);
export default __webpack_public_path__ + "static/media/ico-location-dot-orange.55a40605ad63246850ab626a6c28323e.svg";
export { ForwardRef as ReactComponent };